import { cachePromise } from './../util/cache_promise';

import $r from 'sitewide-js/core_pre_webpack/routes';

export const ResearchInterestFollowerCountService = cachePromise((params) => {
  const queryParams = Object.assign({ subdomain_param: 'api' }, params);

  return $.getJSON($r.count_api_v0_interest_followers_path(queryParams));
});

export const UserViewCountService = cachePromise((params) => {
  const queryParams = Object.assign({ subdomain_param: 'api' }, params);

  return $.getJSON($r.api_v0_user_stats_path(queryParams));
});

export const UserFollowerCountService = cachePromise((params) => {
  const queryParams = Object.assign({ subdomain_param: 'api' }, params);

  return $.getJSON($r.api_v0_user_followers_path(queryParams));
});

export const UserWorkCountService = cachePromise((params) => {
  const queryParams = Object.assign({ subdomain_param: 'api' }, params);

  return $.getJSON($r.count_api_v0_user_works_path(queryParams));
});

export const FollowUserService = (userId, type) => {
  const data = { _method: type, source: 'news_feed' };

  return $.ajax({
    type: type,
    url: $r.api_v0_user_following_index_path({
      subdomain_param: 'api',
      user_id: userId,
    }),
    data: data,
  });
};

const InterestFollowingsService = (interestId, url) => {
  return $.ajax({
    type: 'POST',
    url: url({
      subdomain_param: 'api',
      tag_type: 'ResearchInterest',
      target_type: 'User',
      target_id: Aedu.User.current.id,
    }),
    data: {
      tag: {
        id: interestId,
      },
    },
  });
};

export const FollowInterestService = (interestId) => {
  return InterestFollowingsService(interestId, $r.add_api_v0_taggings_path);
};

export const UnfollowInterestService = (interestId) => {
  return InterestFollowingsService(interestId, $r.remove_api_v0_taggings_path);
};

// TODO(jacob): despite requesting 'discussion_id', this route really wants an attendee_invitation_token. Remame the route param.
export const JoinDiscussionService = (invitationToken) => {
  return $.ajax({
    type: 'POST',
    url: $r.api_v0_discussion_audience_invitations_path({
      subdomain_param: 'api',
      discussion_id: invitationToken,
      source: 'news',
    }),
  });
};

// creates a RelatedWorkRejection for the given work
export const RejectRelatedWorkService = (workId, category) => {
  return $.ajax({
    type: 'POST',
    url: $r.api_v0_related_work_rejections_path({ subdomain_param: 'api' }),
    data: {
      source: 'news_feed_work_card',
      work_id: workId,
      source_id: workId, // rejection came from a WorkCard -- "id of the record that generated the RelatedWorkRejection"
      for_work_id: null, // the rejection is about the work itself, and not a related work relatedionship
      category: category, // personal preferance or general (spam)
    },
  });
};

// submits multiple-choice survey results
export const SurveyReponseService = (choices) => {
  return $.ajax({
    type: 'POST',
    url: $r.api_v0_survey_submit_path({ subdomain_param: 'api' }),
    dataType: 'JSON',
    data: {
      choices: choices,
      freeform: null,
      survey_type: 'news_feed_work_rejection_survey',
      survey_version: 1,
    },
  });
};

// fetches user suggestions that the current user might want to share the this work with
export const WorkShareSuggestionService = (workId) => {
  return $.ajax({
    type: 'GET',
    url: $r.api_v0_suggestions_work_shares_path({
      work_id: workId,
      subdomain_param: 'api',
    }),
  });
};

export const AddToLibraryService = (workId, source) => {
  let fromDownloadAt = null;
  if (source === 'download') {
    fromDownloadAt = new Date();
  }

  return $.ajax({
    type: 'POST',
    url: $r.api_v0_bookmarks_path({
      'bookmark[content_id]': workId,
      'bookmark[content_type]': 'Work',
      'bookmark[source]': source,
      'bookmark[from_download_at]': fromDownloadAt,
      subdomain_param: 'api',
    }),
  });
};

export const RemoveFromLibraryService = (workId) => {
  return $.ajax({
    type: 'DELETE',
    url: $r.destroy_for_work_api_v0_bookmarks_path({
      content_id: workId,
      subdomain_param: 'api',
    }),
  });
};
